import React, { useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import NotificationsLayer from "../components/NotificationsLayer";
import { Icon } from "@iconify/react";



const NotificationsPage = () => {
  // Default to the panel view when landing on the Work Requests page
  const [viewMode, setViewMode] = useState("panel");

  const headerActions = (
    <div className="btn-group" role="group">
      <button
        type="button"
        className={`btn btn-sm ${viewMode === 'table' ? 'bg-white text-muted border-light' : 'btn-light-100 text-muted'}`}
        onClick={() => setViewMode('table')}
      >
        <Icon icon="ic:baseline-table-view" className="icon text-xl line-height-1" /> Table
      </button>
      <button
        type="button"
        className={`btn btn-sm ${viewMode === 'panel' ? 'bg-white-300 text-muted border-light' : 'btn-light-100 text-muted'}`}
        onClick={() => setViewMode('panel')}
      >
        <Icon icon="ic:baseline-view-sidebar" className="icon text-xl line-height-1" /> Panel
      </button>
    </div>
  );

  return (
    <>
      <MasterLayout pageTitle="Work Requests" headerActions={headerActions}>
        <NotificationsLayer viewMode={viewMode} />
      </MasterLayout>
    </>
  );
};

export default NotificationsPage; 
